import { BaseError } from './base-error';

export class ObjectNotFoundError extends BaseError {}
